import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=c75455aa&scoped=true&"
import script from "./Categories.vue?vue&type=script&lang=js&"
export * from "./Categories.vue?vue&type=script&lang=js&"
import style0 from "./Categories.vue?vue&type=style&index=0&id=c75455aa&scoped=true&lang=scss&"
import style1 from "./Categories.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75455aa",
  null
  
)

export default component.exports